/** KO translations for Les Aiguilles Blanches */
const ko: Record<string, string> = {
  subtitle: "설상차 시뮬레이터",
  startGame: "게임 시작",
  resumeGame: "이어하기",
  newGame: "새 게임",
  // UNUSED continue: "계속",
  settings: "설정",
  controls: "조작",
  changelog: "업데이트",
  howToPlay: "게임 방법",
  fullscreen: "전체 화면",
  fullscreenHint: "F키로 전체 화면",
  exitFullscreen: "전체 화면 해제",
  back: "뒤로",
  backToGame: "게임으로 돌아가기",
  // UNUSED loading: "로딩 중...",
  inputKeyboard: "✓ 키보드 감지됨",
  inputKeyboardOff: "✗ 키보드 없음",
  inputTouch: "✓ 터치스크린 감지됨",
  inputTouchOff: "✗ 터치스크린 감지 안 됨",
  inputGamepad: "✓ 게임패드 연결됨",
  inputGamepadOff: "✗ 게임패드 없음",
  updateAvailable: "새 버전이 있습니다 — 탭하여 새로고침",
  madeIn: "❄️ 사부아에서 제작",
  feedback: "피드백 보내기",
  on: "✓ 켜기",
  off: "✗ 끄기",
  zoneClosed: "🚫 구역 폐쇄",

  // Settings
  language: "언어",
  accessibility: "접근성",
  highContrast: "고대비",
  reducedMotion: "모션 감소",
  showFps: "FPS 표시",
  showDebug: "디버그 정보",
  skiStyle: "스타일",
  skiTricks: "트릭",
  skiBestCombo: "최고 콤보",
  quitGame: "게임 종료",
  display: "화면",
  displayWindowed: "창 모드",
  displayFullscreen: "전체 화면",
  displayBorderless: "테두리 없음",
  colorblindMode: "색맹 보정",
  none: "없음",
  deuteranopia: "2형",
  protanopia: "1형",
  tritanopia: "3형",
  // UNUSED move: "이동",
  moveUp: "위",
  moveDown: "아래",
  moveLeft: "왼쪽",
  moveRight: "오른쪽",
  groom: "정설",
  winch: "윈치",
  pause: "일시정지",
  keyboard: "키보드",
  clickToRebind: "클릭하여 변경",
  pressKey: "키를 누르세요...",
  pressGamepadButton: "버튼을 누르세요...",
  noGamepad: "게임패드 미연결",
  gamepadButtons: "게임패드",
  saved: "저장됨!",
  resetControls: "초기화",
  controlsReset: "조작 초기화됨!",
  movementSensitivity: "감도",
  keyboardLayout: "레이아웃",
  customBindings: "사용자 지정",
  // UNUSED gamepadSupported: "게임패드 OK",
  touch: "터치",
  // UNUSED touchSupported: "터치 OK",
  noGamepadConnected: "게임패드 미연결",
  gamepadDiagnostic: "컨트롤러 테스트",
  connectGamepadDiag: "컨트롤러를 연결하여 테스트",
  gamepadDiagButtons: "버튼",
  gamepadDiagSticks: "스틱",
  gamepadDiagTriggers: "트리거",

  // Audio
  audio: "오디오",
  masterVolume: "마스터 볼륨",
  musicVolume: "음악",
  sfxVolume: "효과음",
  engineVolume: "엔진",
  voiceVolume: "음성",
  ambienceVolume: "환경음",
  mute: "음소거",

  backgroundAudio: "백그라운드 오디오",
  // Gameplay
  bonus: "보너스",
  skiMode: "활강 모드",
  ski: "스키",
  snowboard: "스노보드",
  random: "랜덤",
  skiIt: "스키 타자!",
  rideIt: "보드 타자!",
  skiAgain: "다시 타기!",
  rideAgain: "다시 타기!",
  skiRunSpeed: "속도",
  skiRunTime: "시간",
  skiRunGates: "게이트",

  // How to Play hints
  howToPlayMove: "{keys} 또는 방향키로 이동",
  howToPlayMoveTouch: "가상 D패드로 이동",
  howToPlayMoveGamepad: "왼쪽 스틱 또는 D패드로 이동",
  howToPlayMoveHybrid: "{keys}/방향키 또는 터치 D패드",
  howToPlayGroom: "{groomKey}로 정설",
  howToPlayGroomTouch: "정설 버튼 길게 누르기",
  howToPlayGroomGamepad: "으로 정설",
  howToPlayGroomHybrid: "{groomKey} 또는 정설 버튼 길게 누르기",
  howToPlayFuel: "연료와 체력에 주의!",
  howToPlayWinch: "앵커 근처에서 {winchKey}로 윈치 연결",
  howToPlayWinchTouch: "앵커 근처에서 윈치 버튼 길게 누르기",
  howToPlayWinchGamepad: "앵커 근처에서 윈치 연결",
  howToPlayWinchHybrid: "{winchKey} 또는 앵커 근처에서 윈치 버튼 길게 누르기",

  // Winch
  winchSnapped: "💥 케이블 끊김!",
  winchAttached: "🔗 윈치 연결! {winchKey} 길게 눌러 보조.",
  winchActive: "윈치",
  // UNUSED winchHint: "번호 앵커 포스트 근처에서 {winchKey}를 눌러 윈치 사용",
  // UNUSED winchHintTouch: "🔗 길게 눌러 윈치",
  // UNUSED accessPath: "작업 도로",
  // UNUSED toPiste: "슬로프로",

  // Taunts - Cliff falls
  tauntCliff1: "9톤이 계곡 아래로. 보험사가 좋아할 거야.",
  tauntCliff2: "장피에르가 '절벽에 가까이 가지 마!'라고 했던 거 기억나?",
  tauntCliff3: "구조대가 또 로프를 들고 내려온다.",
  tauntCliff4: "마리가 오늘 밤 라클렛 예약을 취소했다.",
  tauntCliff5: "티에리가 벌써 수리비를 계산하고 있다...",

  // Taunts - Fuel empty
  tauntFuel1: "10분 전부터 연료 경고등이 켜져 있었는데. 뭘 보고 있었어?",
  tauntFuel2: "에밀리가 게시판에 '급유'라고 크게 써놨었다.",
  tauntFuel3: "경유에도 한계가 있다. 너도 마찬가지인 모양이다.",
  tauntFuel4: "장피에르가 한숨을 쉰다. 티에리에게 휴대용 연료통을 보냈다.",
  tauntFuel5: "해가 떴다. 슬로프는 미정비. 스키어들이 온다.",

  // Taunts - Time limit
  tauntTime1: "첫 리프트까지 3...2...1...놓쳤다.",
  tauntTime2: "스키어들이 슬로프를 발견했다. 울퉁불퉁. 빙판. 훌륭하다.",
  tauntTime3: "장피에르가 시계를 보고, 너를 보고, 다시 시계를 본다.",
  tauntTime4: "FIS가 왜 슬랄롬 코스가 수프 같은지 묻고 있다.",
  tauntTime5: "강사들이 손님에게 '자기 탓이 아니다'라고 설명하는 소리가 들린다.",

  // UNUSED paused: "일시정지",
  resume: "이어하기",
  quitToMenu: "메뉴로 돌아가기",
  levelComplete: "코스 클리어!",
  levelFailed: "코스 실패",
  tryAgain: "다시 시도",
  coverage: "정비율",
  time: "시간",
  // UNUSED rating: "평가",
  nextLevel: "다음 코스",
  // UNUSED replay: "리플레이",
  // UNUSED pressContinue: "스페이스바 또는 탭으로 계속",
  pauseTitle: "⏸️ 일시정지",
  restart: "다시 시작",
  skipRun: "활강 건너뛰기",
  newRun: "새 슬로프",
  quit: "종료",
  menu: "메뉴",
  levelSelect: "슬로프 맵",
  locked: "폐쇄",
   completeToUnlock: "{name} 완료하여 잠금 해제",
  // UNUSED target: "목표",
  tutorial: "스키 스쿨",
  timeUsed: "경과 시간",
  excellent: "훌륭해!",
  good: "잘했어!",
  passed: "통과",
  bonusFuel: "연료 소비",
  bonusFlawless: "첫 시도 클리어",
  bonusSpeed: "시간",
  bonusWinch: "윈치 사용",
  bonusExplore: "도로 탐색",
  bonusPrecision: "정비 품질",
  retry: "재시도",
  gameComplete: "게임 클리어!",
  viewCredits: "크레딧",
  creditsTitle: "축하합니다!",
  creditsSubtitle: "Les Aiguilles Blanches를 정복했습니다",
  creditsCreatedBy: "제작",
  creditsDevelopedWith: "개발 도구",
  creditsArtDirection: "아트 디렉션",
  creditsRetroInspiration: "SkiFree 같은 레트로 명작에 대한 오마주",
  creditsInspiredBy: "영감",
  creditsGroomers: "사부아의 설상차 운전사들",
  creditsDedication: "우리가 잠든 사이 슬로프를 준비하는 야간 팀에게",
  creditsThanks: "플레이해 주셔서 감사합니다!",
  creditsSeeYou: "슬로프에서 또 만나요!",
  creditsLine: "자, 꼬마야. 해가 뜬다. 산은 준비됐어.",
  playAgain: "다시 플레이",
  skipCredits: "아무 키를 눌러 건너뛰기",

  // Tutorial
  tutorialName: "튜토리얼 - 첫 걸음",
  tutorialTask: "정설 기초를 배우기",
  prologueLine: "새벽 4시. 산은 네 거다. 일이다.",
  prologueSkip: "아무 키나 눌러 계속",
  tutorialIntro: "Les Aiguilles Blanches에 오신 것을 환영합니다!",
  skipTutorial: "⏭️ 튜토리얼 건너뛰기…탭으로 다시 보기.",
  skipTutorialGamepad: "⏭️ 튜토리얼 건너뛰기…버튼으로 다시 보기.",
  tutorialWelcome: "🏔️ 장피에르, 수석 정설 담당이다. 슬로프를 돌아다녀 — {keys} 또는 ↑↓←→를 사용해.",
  tutorialWelcomeTouch: "🏔️ 장피에르, 수석 정설 담당이다. 슬로프를 돌아다녀 — 왼쪽의 D패드를 사용해.",
  tutorialWelcomeGamepad: "🏔️ 장피에르, 수석 정설 담당이다. 슬로프를 돌아다녀 — 왼쪽 스틱이나 D패드를 사용해.",
  // UNUSED     tutorialControls: "🎮 설상차를 움직이려면 {keys} 또는 방향키 ↑↓←→를 사용해.",
  // UNUSED     tutorialControlsTouch: "🎮 설상차를 움직이려면 왼쪽의 D패드 ◀▲▼▶를 사용해.",
  // UNUSED     tutorialControlsGamepad: "🎮 설상차를 움직이려면 왼쪽 스틱이나 D패드를 사용해.",
  // UNUSED     tutorialMove: "➡️ 자, 해봐! 슬로프를 돌아다녀 — 모든 하얀 눈을 정설해야 해.",
  // UNUSED     tutorialGroomIntro: "✅ 좋아! 이제 정설을 배워보자.",
  tutorialGroomAction: "❄️ {groomKey}를 누르면서 주행하면 눈이 정비돼. 깔끔해질 거야.",
  tutorialGroomActionTouch: "❄️ 오른쪽의 정설 버튼을 누르면서 주행하면 눈이 정비돼.",
  tutorialGroomActionGamepad: "❄️ {groomKey}를 누르면서 주행하면 눈이 정비돼. 깔끔해질 거야.",
  tutorialGroomGoal: "📊 바로 그거야! 개장 전까지 60% 이상 정비해. 스키어들이 오고 있어!",
  // UNUSED   tutorialCoverage: "📊 봐! 눈이 깔끔해지고 있어! 슬로프 정설을 계속해.",
  // UNUSED   tutorialHUD: "📈 위의 대시보드를 확인해: 빨간 바는 연료, 초록은 체력, 흰색은 정비율. 시계도 확인해!",
  // UNUSED   tutorialGoal: "🎯 개장 전까지 슬로프의 60% 이상을 정비해야 해. 스키어들이 오고 있어!",
  // UNUSED tutorialFuel: "⛽ 조심해 — 주행하면 연료가 소모돼. 미션에서는 주유소에 들러.",
  tutorialComplete: "🏆 잘했어! 기초를 마스터했어. 첫 미션, 초급 코스에 도전할 준비가 됐어?",

  level_marmottesName: "초급 코스 - Les Marmottes",
  level_marmottesTask: "초급 슬로프 정비",
  level_chamoisName: "중급 코스 - Le Chamois",
  level_chamoisTask: "개장 전에 효율적으로 정비",
  level_airZoneName: "스노파크 - Air Zone",
  level_airZoneTask: "프리스타일 시설 준비",
  level_aigleName: "상급 코스 - L'Aigle",
  level_aigleTask: "급경사면 정비, 연료 관리",
  level_glacierName: "상급 코스 - Le Glacier",
  level_glacierTask: "급경사면에서 윈치 사용법 학습",
  level_tubeName: "하프파이프 - Le Tube",
  level_tubeTask: "대회용 하프파이프 정비",
  level_verticaleName: "최상급 코스 - La Verticale",
  level_verticaleTask: "야간 작업, 윈치 사용",
  level_colDangereuxName: "눈사태 구역 - Col Dangereux",
  level_colDangereuxTask: "고위험 구역 준비",
  level_tempeteName: "폭풍 - 복구 작업",
  level_tempeteTask: "폭풍 후 슬로프 복구",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - FIS 결승",
  level_coupeDesAiguillesTask: "대회를 위해 전 코스 정비",

  // Hazards
  cliffFall: "⚠️ 경고! 절벽에서 떨어졌다! 미션 실패.",
  fuelEmpty: "⛽ 연료 없음! 경유가 한 방울도 없다...",
  // UNUSED avalancheZone: "눈사태 구역",
  riskLevelHigh: "높음",
  avalancheWarning: "⚠️ 위험! 적설이 불안정! 구역을 벗어나라!",
  avalancheTrigger: "🏔️💨 눈사태 발생! 탈출 불가!",
  steepWarning: "⚠️ 급경사! 윈치({winchKey})를 사용해, 미끄러진다!",
  steepWarningNoWinch: "⚠️ 급경사! 속도를 줄이고 작업 도로로 우회해!",
  tumble: "🔄 전복! 설상차가 경사면에서 굴렀다!",

  // Taunts - Tumble
  tauntTumble1: "윈치는 장식이 아니다. 이런 경사면을 위한 거야.",
  tauntTumble2: "티에리가 손상을 바라본다. 아무 말이 없다. 그게 더 나쁘다.",
  tauntTumble3: "장피에르가 앵커 사용법을 보여줬는데. 자고 있었어?",
  tauntTumble4: "PistenBully는 5억 원이다. 아니, 이었다.",
  tauntTumble5: "이 경사면이 만만해 보였어? 설상차는 그렇게 생각 안 했어.",
  featureDestroyedKicker: '파크 모듈 위로 지나갔어! 키커가 파괴됐어.',
  featureDestroyedRail: '파크 모듈 위로 지나갔어! 레일이 파괴됐어.',
  tauntFeature1: '그 모듈은 3시간 걸렸는데. 3초 만에 밀어버렸네.',
  tauntFeature2: '에밀리가 그 파크 모듈에 대해 할 말이 있대.',
  tauntFeature3: '파크 팀이 걸작이 파괴되는 걸 지켜봤어.',
  tauntFeature4: '모듈은 스키어용이야. 설상차는 돌아가!',
  tauntFeature5: '내일 대회용 모듈이 하나 줄었어.',
  bonusPipeMastery: '하프파이프 마스터',

  // Taunts - Avalanche
  tauntAvalanche1: "산은 좀처럼 용서하지 않는다. 이번에도 용서하지 않았다.",
  tauntAvalanche2: "Météo France가 위험도 4라고 했는데. 읽었어?",
  tauntAvalanche3: "봄이 되면 설상차를 찾을 수 있을 거다. 아마.",
  tauntAvalanche4: "마리가 무전 경보를 들었다. 범인이 누군지 벌써 안다.",
  tauntAvalanche5: "구조대가 그 구역을 안전하게 만들었었다. 네가 원상복구시켰다.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "완벽한 낙법 실패. 장비는 사방에, 자존심은 어디에도.",
  tauntSkiWipeout2: "절벽은 네 스키 기술에 관심이 없었다.",
  tauntSkiWipeout3: "구조대가 이미 웃고 있다. 전부 봤다.",
  tauntSkiWipeout4: "자기가 정비한 슬로프에서 넘어지다니.",
  tauntSkiWipeout5: "산양들도 그 착지를 보고 얼굴을 찡그렸다.",

  jeanPierreIntro: "튜토리얼 잘했어. 이제 진짜다 — 초급 코스, 시간 제한과 연료 관리가 있어.",
  level_marmottesMid: "봉우리의 저 빛이 보여? 첫 여명이야. 이 일의 가장 좋은 순간 — 너, 기계, 그리고 깨어나는 산뿐이지.",
  level_chamoisIntro: "안녕, 나 에밀리야 — 장피에르가 중급 코스로 보내. 초급만 하는 게 아니라는 걸 보여줘.",
  level_airZoneIntro: "스노파크는 내 영역이야 — 끝내주는 코스를 만들 거야! 모듈 하나하나 완벽해야 해, 라이더들이 기대하고 있거든.",
  level_aigleIntro: "L'Aigle은 진짜다. 연료에 주의해. 작업 도로로 올라갈 수 있어 — 노란색과 검은색 줄무늬 기둥을 찾아.",
  level_glacierIntro: "안녕, 나 티에리야 — 안전 관리 책임자. Le Glacier는 급경사야. 앵커는 전부 확인했어. 포스트 근처에서 {winchKey}를 눌러 윈치를 연결해 — 제발, 놓지 마.",
  level_glacierIntroTouch: "안녕, 나 티에리야 — 안전 관리 책임자. Le Glacier는 급경사야. 앵커는 전부 확인했어. 포스트 근처에서 윈치 버튼을 탭해 — 제발, 놓지 마.",
  level_tubeIntro: "내일 Tube에서 대회야! 벽은 깔끔하게, 립은 날카롭게, 요철은 제로로 만들어줘.",
  level_verticaleIntro: "La Verticale 야간 작업: 급경사, 위험한 가장자리. 윈치 필수 — 앵커 3개를 사용하고 축에서 벗어나지 마.",
  level_colDangereuxIntro: "Col의 눈사태 위험이 높아 — 눈사태 안전 프로토콜 발동 중. 하중 구역에 들어가지 말고 경계를 지켜.",
  level_tempeteIntro: "폭풍이 지나갔어. 뱅쇼 한 잔 마셔 — 시간이 걸릴 거야!",
  level_coupeDesAiguillesIntro: "오늘 밤이 승부야. 내일 FIS 검사가 있어. 모든 코스가 완벽해야 해 — 배운 걸 보여줘.",
  marieWelcome: "마리네에서 몸 좀 녹여요. 맛있는 타르티플레트가 있어요!",
  marieIntro: "안녕! 나 마리야, 슬로프 위에 식당을 운영해. 언제든 들러 — 따뜻한 한 끼가 힘이 돼!",

  // Changelog
  changelog_20260219_date: "2026년 2월 19일",
  changelog_20260219: "🎬 신규 플레이어 프롤로그\n📖 튜토리얼 간소화\n🌦️ 메뉴 랜덤 날씨\n🔗 데일리 런 공유\n🎥 시네마틱 크레딧",
  changelog_20260222_date: "2026년 2월 22일",
  changelog_20260222: "🚩 슬라롬 게이트 밸런스 조정\n💬 피드백 버튼",
  changelog_20260223_date: "2026년 2월 23일",
  changelog_20260223: "📲 기기에 설치하고 오프라인으로 플레이",
  changelog_20260220_date: "2026년 2월 20일",
  changelog_20260220: "🗺️ 슬로프 맵\n🎿 스키장 용어",
  changelog_20260217_date: "2026년 2월 17일",
  changelog_20260217: "🏔️ 7종 코스 형태\n🎯 코스 생성 다양성\n⚡ 스키 활주 개선",
  changelog_20260216_date: "2026년 2월 16일",
  changelog_20260216: "🎲 오늘의 슬로프",
  changelog_20260215_date: "2026년 2월 15일",
  changelog_20260215: "⚡ 야간 렌더링 개편\n📱 스키 모드 터치 버튼\n⌨️ 키보드 레이아웃 감지",
  changelog_20260214_date: "2026년 2월 14일",
  changelog_20260214: "🎪 트릭 점수 & 콤보\n🏂 크라우치 & 하프파이프 물리\n👁️ 슬로프 대비 개선\n📱 윈치 시 자동 정설 (터치)\n♿ 고대비 모드",
  changelog_20260213_date: "2026년 2월 13일",
  changelog_20260213: "🚩 슬라럼 게이트\n🏔️ 스키 점프\n⚡ 성능 향상\n🎹 녹턴 피아노 음악\n🔊 엔진 볼륨 조절",
  changelog_20260212_date: "2026년 2월 12일",
  changelog_20260212: "📋 슬로프 맵\n🔗 끊어지는 윈치 케이블\n🕹️ 컨트롤러 진단\n🍽️ 마리의 요리\n❄️ 냉기 노출",
  changelog_20260211_date: "2026년 2월 11일",
changelog_20260211: "⛷️ 정비 후 스키 활강\n🎯 정비 품질\n🏔️ 색상 구분된 급경사 구간\n🏗️ 파크와 트릭",
  changelog_20260210_date: "2026년 2월 10일",
  changelog_20260210: "🎵 음악과 효과음\n🔈 볼륨 설정\n⏱️ 자동 조정 코스 타임\n⏭️ 튜토리얼 건너뛰기\n🏔️ 눈사태 구역 재설계",
  changelog_20260209_date: "2026년 2월 9일",
  changelog_20260209: "🏔️ 알프스풍 클리어/실패 화면\n❄️ 폭풍 적설\n🏆 노미스 보너스\n🔊 날씨와 야생동물 환경음",
  changelog_20260208_date: "2026년 2월 8일",
  changelog_20260208: "📊 대시보드 개편\n🏔️ Le Glacier와 Coupe des Aiguilles\n🦅 고산 야생동물\n🎨 캐릭터 초상화\n🎮 키보드/게임패드 조작",
  changelog_20260207_date: "2026년 2월 7일",
  changelog_20260207: "🎨 레트로 UI\n🎯 보너스 목표\n🕹️ 게임패드 버튼 변경\n🎮 게임패드 메뉴 조작",
  changelog_20260206_date: "2026년 2월 6일",
  changelog_20260206: "🛤️ 주행 가능한 작업 도로\n🕹️ 가상 조이스틱\n🌍 5개 언어 지원",
  changelog_20260205_date: "2026년 2월 5일",
  changelog_20260205: "🏔️ 바위 절벽\n🌙 야간 헤드라이트\n🔗 윈치 메커니즘\n⌨️ 키보드 조작",
  changelog_20260204_date: "2026년 2월 4일",
  changelog_20260204: "🎮 게임패드 지원\n📱 터치 조작\n💪 스태미나\n💾 저장 기능\n♿ 접근성",
  changelog_20260203_date: "2026년 2월 3일",
  changelog_20260203: "🚜 출시: 9개 코스, 스키 스쿨\n❄️ 정설, 연료, 눈사태\n🏆 크레딧과 진행",
  // Key names
  key_space: "스페이스",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "DEL",
  dailyRuns: "오늘의 슬로프",
  dailyRuns_dailyShift: "일일 근무",
  dailyRuns_randomRun: "랜덤 런",
  dailyRuns_rank: "등급",
  dailyRuns_seed: "시드",
  // UNUSED   dailyRuns_start: "계약 시작",
  dailyRuns_locked: "모든 코스를 완료하면 해제됩니다",
  dailyRuns_lockedShared: "모든 코스를 완료하여 데일리 런을 잠금 해제하고 이 공유 코스를 플레이하세요",
  // UNUSED   dailyRun_levelName: "계약",
  dailyRun_levelTask: "목표 커버리지까지 슬로프를 정비하세요",
  dailyRuns_briefing: "브리핑",
  dailyRuns_target: "목표",
  dailyRuns_timeLimit: "시간",
  dailyRuns_weather_clear: "맑은 하늘",
  dailyRuns_weather_light_snow: "가벼운 눈",
  dailyRuns_weather_storm: "폭풍 상황",
  dailyRuns_night: "야간 근무",
  dailyRuns_day: "주간 근무",
  rank_green: "그린",
  rank_blue: "블루",
  rank_red: "레드",
  rank_black: "블랙",
  rank_park: "파크",
  share: "공유",
  copied: "링크 복사됨!",
  playSharedSeed: "공유 런",
  dailyRunBriefingJP: "리프트 열기 전에 슬로프 정비 끝내. 빨리 움직여.",
  dailyRunBriefingThierry: "조심해 — 급경사에 불안정한 눈이야. 긴장 늦추지 마.",
  dailyRunBriefingMarie: "오늘 밤은 많이 추울 거야. 몸 녹이려면 식당에 들러.",
  dailyRunBriefingEmilie: "또 슬로프 하나 더! 내 기록 깰 수 있을까?"
};

export default ko;
